import React from "react";
import AnimatedHeroGraphic from "./AnimatedHeroGraphic";

const RightBanner = () => {
  return (
    <div className="hidden lgl:flex w-full lgl:w-1/2 justify-center items-center relative py-10 lgl:py-0 mt-8 lgl:mt-0">
      <AnimatedHeroGraphic />
    </div>
  );
};

export default RightBanner;